import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import EditUser from './editUser';

class MemberActiveUsers extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			activeSection: 'table',
			users: [],
			userEditId: '0'
		};
	
		this.createUserRow = this.createUserRow.bind(this);
		this.editUser = this.editUser.bind(this);
		this.backtoTable = this.backtoTable.bind(this);
	}

	componentDidMount() {
		//console.log('MemberActiveUsers: componentDidMount');
		this.loadUsers();
	}

	loadUsers() {
		Axios.get('/api/users/activeMembers').then(response => {
			this.setState({	users: response.data });
		});
	}

	render() {
		//console.log('MemberActiveUsers: render');
		//console.log(this.props)
		const { activeSection } = this.state;

		return (
			<div className="row">
			<div className="col-md-12">

				<h5>Members Statelo</h5>
				<div className="card">
					<div className="card-header">
						<i className="fa fa-th-large"></i>
						Members Statelo
					</div>

					{ (activeSection === 'table') ? 
						<div className="card-block">
							{this.showMembersTable()}
						</div>
					: null}

					{ (activeSection === 'editUser') ? 
						<div className="card-block">
							{this.showEditUser()}
						</div>
					: null}

				</div>
			</div>
			</div>
		);
	}

	showMembersTable() {
		return(
			<div className="table-responsive">
				<table className="table table-striped table-hover table-sm">
				<tbody>
					<tr>
						<th></th>
						<th></th>
						<th>ids (user._id, auth0_user_id)</th>
						<th>Noms (auth0, user)</th>
						<th>Joueur Associé</th>
						<th>Expiration</th>
						<th>Dernière connection</th>
					</tr>
					{this.state.users.map(this.createUserRow)}
				</tbody>
				</table>
			</div>
		)
	}

	createUserRow(user, userIdx) {
		return (
			<tr key={user._id}>
				<td><input name={'edit.' + user._id} type="button" onClick={this.editUser} value="Éditer"/></td>
				<td><img className="img-stand-token" src={user.picture}/></td>
				<td>{user._id} <br/>
					{user.auth0_user_id}</td>
				<td>{user.auth0_name} <br/>
					{user.name}</td>
				<td>{user.playerName}</td>
				<td>{moment(user.memberDateExpiration).format("YYYY-MM-DD")} <br/>
					{moment(user.memberDateExpiration).format("HH:mm:ss")}</td>
				<td>{moment(user.lastConnectionDate).format("YYYY-MM-DD")} <br/>
					{moment(user.lastConnectionDate).format("HH:mm:ss")}</td>
		   </tr>
		);
	}

	editUser(e) {
		const elemInfo = e.target.name.split(".");
		const userEditId = elemInfo[1];
		this.setState({ 
			activeSection: 'editUser',
			userEditId: userEditId
		});
	}

	showEditUser() {
		const { userEditId } = this.state;
		return ( <EditUser userEditId={userEditId} onSubmitCancel={this.backtoTable} />	)
	}

	backtoTable () {
		this.setState({ 
			activeSection: 'table',
			userEditId: '0'
		}, this.loadUsers());
	}
}

export default MemberActiveUsers;
